import Dom from '../shared/dom';

export default class StickyBar {
    constructor(node) {
        this.node = node;
        this.isActive = false;
        this.isEnding = false;
        this.startingElement = document.querySelector(this.node.getAttribute('data-sticky-on'));
        this.endingElement = document.querySelector(this.node.getAttribute('data-sticky-off'));
        this.button = this.node.querySelector('[data-sticky-scrollto]');
        this.scrollToElement = document.querySelector(this.button.getAttribute('data-sticky-scrollto'));
        this.hideVal = this.startingElement.offsetTop;
        this.addListener();
    }

    addListener() {
        window.addEventListener('scroll', (e) => {
            this.onScroll();
        });

        this.button.addEventListener('click', (e) => {
            this.scrollTo();
        });
    }

    onScroll() {
        if(window.scrollY > this.hideVal) {
            if (!this.isActive) {
                this.able();
            } else {
                this.disableOnEnd();
            }
        } else {
            if(this.isActive) {
                this.disable();
                
            } 
        }
    }

    scrollTo() {
        window.scrollTo({
            top: this.scrollToElement.offsetTop - 60,
            behavior: 'smooth'
        });
    }

    able() {
        this.node.style.bottom = 0;
        this.isActive = true;
    }

    disable() {
        this.node.style.bottom = -this.node.clientHeight + 'px';
        this.isActive = false;
    }

    disableOnEnd() {
        let endingTop = this.endingElement.getBoundingClientRect().top;
        let offsetEnd = Dom.mobile && !Dom.tablet ? endingTop : endingTop - this.endingElement.clientHeight;
        this.node.style.bottom = offsetEnd < 0 ? -this.node.clientHeight + 'px' : 0;       
    }
    
    static updatePrices(priceWrap, quantityWrap) {
        let stickyPrice = StickyBar.item.querySelector('.price');
        let stickyQuantity = StickyBar.item.querySelector('.quantity');
		stickyPrice.innerHTML = priceWrap.innerHTML;
		stickyQuantity.innerHTML = quantityWrap.innerHTML;
    }

    static init() {
        StickyBar.item = document.querySelector("[data-sticky-bar]");
        if (StickyBar.item) {
            return new StickyBar(StickyBar.item);
        }
    }
}